import { apiFetch } from '../utils/api';
import config from '../config';

/**
 * Notification API Service
 * Interacts with backend notification endpoints using the existing apiFetch client.
 */

export const fetchNotifications = async ({ page = 1, limit = 20, unreadOnly = false } = {}) => {
  const query = new URLSearchParams();
  if (page) query.append('page', page);
  if (limit) query.append('limit', limit);
  if (unreadOnly) query.append('unreadOnly', 'true');

  const endpoint = config.API_ENDPOINTS?.NOTIFICATIONS?.LIST || `${config.API_BASE_URL}/api/notifications`;
  const url = `${endpoint}?${query.toString()}`;
  const response = await apiFetch(url);
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || errorData.error || 'Failed to fetch notifications');
  }
  return response.json();
};

export const fetchUnreadCount = async () => {
  const endpoint = config.API_ENDPOINTS?.NOTIFICATIONS?.UNREAD_COUNT || `${config.API_BASE_URL}/api/notifications/unread-count`;
  const response = await apiFetch(endpoint);
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || errorData.error || 'Failed to fetch unread count');
  }
  return response.json();
};

export const markAsRead = async (id) => {
  if (!id) throw new Error('Notification ID is required');
  const endpointFn = config.API_ENDPOINTS?.NOTIFICATIONS?.MARK_READ || ((nId) => `${config.API_BASE_URL}/api/notifications/${nId}/read`);
  const url = endpointFn(id);
  const response = await apiFetch(url, { method: 'PATCH' });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || errorData.error || 'Failed to mark notification as read');
  }
  return response.json();
};

export const markAllAsRead = async () => {
  const endpoint = config.API_ENDPOINTS?.NOTIFICATIONS?.MARK_ALL_READ || `${config.API_BASE_URL}/api/notifications/read-all`;
  const response = await apiFetch(endpoint, { method: 'PATCH' });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || errorData.error || 'Failed to mark all notifications as read');
  }
  return response.json();
};

const notificationApiService = {
  fetchNotifications,
  fetchUnreadCount,
  markAsRead,
  markAllAsRead,
};

export default notificationApiService;
